module.exports = __webpack_public_path__ + "img/luntan_2018_05.7a6c48ec.jpg";